module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_18.56d4f6ed.jpeg";